/* A call whose socket drops before the server answers is never answered: the store's socket sets no ack timeout and
   socket.io drops the pending callback on disconnect. The code screen refuses to be closed while a call is out
   (it must not sign the guest in under a verify that may still succeed), so the sign-up calls - the verify, the
   resend, and the sign-ins that follow them - are given up after VERIFY_TIMEOUT_MS as reason 'timeout'. The server
   may still have acted: a retried verify then answers 'processed', a resend 'too-soon'.
   Its own module (not feathersStore.js) so the code screen can use it without loading the store and its socket. */
export const VERIFY_TIMEOUT_MS = 30000;
export const withTimeout = (promise, ms = VERIFY_TIMEOUT_MS) => new Promise((resolve, reject) => {
  const timer = setTimeout(() => reject(Object.assign(new Error('No answer from the server'), { data: { reason: 'timeout' } })), ms);
  Promise.resolve(promise).then(
    (value) => { clearTimeout(timer); resolve(value); },
    (error) => { clearTimeout(timer); reject(error); }
  );
});
